// extracted by mini-css-extract-plugin
module.exports = {"faqs":"styles_faqs__oSmW8","rotate":"styles_rotate__ycuxA","rotate-reverse":"styles_rotate-reverse__ETo2s"};